<template>
  <div id="grid-planificacion">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex>
          <br />
          <v-btn
            v-if="
              (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()
            "
            color="primary"
            dark
            class="mb-2"
            @click="openForm()"
            >Nueva Planificacion</v-btn
          >
        </v-flex>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        ></carga-masiva>
      </v-layout>
      <v-spacer></v-spacer>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            item-text="nombre"
            item-value="code"
            :items="nivelSelect"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="fechaValue"
            :items="fechaSelect"
            label="Fecha"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4> </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterGrid()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsRegistro"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.idNivel.descripcion }}</td>
              <td class="text-xs-left">{{ props.item.fechaPrevista }}</td>
              <td class="text-xs-left">{{ props.item.cantidad }}</td>
              <td class="text-xs-left">{{ props.item.cantidad }}</td>
              <td>
                <div class="text-xs-center">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consultar detalle"
                    @click="viewForm(props.item.id)"
                    ><v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </div>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <!-- <v-chip color="orange" dark>Registro con comentario</v-chip> -->
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >&nbsp;Consultar detalle
                </template>
              </td>
            </div>
          </v-card-actions>
          <!--fin iconos leyenda-->
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          dark
          class="mb-2"
          @click="downloadComplete()"
          >Descarga Completa <v-icon right dark>folder</v-icon></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import CargaMasiva from "@/components/CargaMasiva.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-planificacion",
  components: {
    Loading,
    CargaMasiva,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      botonValida: 1,
      loading: false,
      itemsRegistro: [],
      dialogValidation: false,
      dialog: false,
      resp: "",
      contratoId: "",
      itemsProgreso: [],
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Fecha", sortable: false, value: "fecha" },
        {
          text: "Cantidad Prevista",
          align: "left",
          sortable: false,
          value: "region",
        },
        {
          text: "Cantidad Real Informada",
          sortable: false,
          value: "centroAcopio",
        },
        { text: "Accion", sortable: false, value: "accion" },
      ],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsMateriales: [],
      centroAcopio: "",
      centroAcopioValue: null,
      centroAcopioSelect: [],
      nivelValue: null,
      nivelSelect: [],
      tipoMaterialValue: null,
      tipoMaterialSelect: [],
      regionValue: null,
      regionesSelect: [],
      fechaValue: null,
      fechaSelect: [],
      resultadoValue: null,
      resultadoSelect: [],
      filter: false,
      tabSelected: "",
      filex: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    //se indican las apis a utilizar
    this.apiValidateDocument = "/traspasoCaptura/preProcessNewPlanificacion";
    this.apiSaveDocument = "/traspasoCaptura/GuardarPlanificacionMasivo";
    this.apiDownloadDocument =
      "/traspasoCaptura/downloadPlantillaPlanificacion/";
    this.templateTitle = "Planilla_Captura_Planificacion";
    this.loadData();
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    openForm() {
      setTimeout(() => {
        this.$router.push({
          name: "FormPlanificacionCaptura",
          params: { tipeView: "crear", titleView: "Nueva Planificacion" },
        });
      }, 1000);
    },
    viewForm(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormPlanificacionCaptura",
          params: {
            idCronograma: id,
            tipeView: "consulta",
            titleView: "Consulta Planificacion",
          },
        });
      }, 1000);
    },

    async loadRegistrosFilter() {
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        idNivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        fechaTraspaso:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        idContrato: idContrato,
      };
      return await axios
        .post("/traspasoCaptura/getAllFilterPlanificacion", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsRegistro = await this.loadRegistrosFilter();
      this.miPaginacion.totalItems = this.itemsRegistro.length;
      this.loading = false;
      if (this.itemsRegistro.length > 0) {
        this.loadNivel();
        this.loadFechaSelect();
      }
    },
    loadNivel() {
      let com = [];
      this.itemsRegistro.forEach(function (c) {
        com.push({
          nombre: c.idNivel.descripcion,
          code: c.idNivel.id,
        });
      });
      this.nivelSelect = com;
      this.nivelValue = this.nivelSelect;
    },
    loadFechaSelect() {
      let est = [];
      this.itemsRegistro.forEach(function (c) {
        let index = est.findIndex((x) => x.fechaPrevista == c.fechaPrevista);
        if (index === -1) {
          est.push(c.fechaPrevista);
        }
      });
      this.fechaSelect = est;
    },
    clear() {
      this.nivelValue = "";
      this.fechaValue = "";
      this.loadData();
    },
    //SOLO NUMEROS
    bloqueoEdicion(tip) {
      if (tip == "AGENCIA") {
        this.bloqueo = true;
      }
      if (tip == "PROVEEDOR") {
        this.bloqueo = false;
      }
      return this.bloqueo;
    },

    filterGrid() {
      this.filter = true;
      this.loadData();
    },

    downloadComplete() {
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Registro_Planificacion_Captura.xlsx";
      if (this.fechaValue != null && this.fechaValue != "") {
      }
      this.body = {
        idNivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        fechaTraspaso:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        idContrato: idContrato,
      };

      axios
        .post("/traspasoCaptura/writeObjectToExcelPlanificacion", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>